import axios from "./configs/axiosConfig";

export const getCustomData = async () => {
  const url = `/customdata`;
  return await axios.get(url);
};
